import { FC, useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';
import { Visibility, Edit } from '@mui/icons-material';

import { Post } from '@libs/models';
import { usePostSearchQuery } from '@carcareers/store';
import { DashboardPageContainer, DataGridV2 as DataGrid } from '@carcareers/components';
import { useDrawer } from '@carcareers/contexts';
import { usePost } from '@carcareers/hooks';
import { POST_INDEX_COLUMN_INITIAL_STATE, POST_INDEX_COLUMNS, routes } from '@carcareers/utils';


export const EmployerPostIndex: FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setOpen } = useDrawer();
  const { deletePost } = usePost();
  const search = usePostSearchQuery;

  const columns = useMemo(
    () => [
      ...POST_INDEX_COLUMNS,
      {
        field: 'actions',
        type: 'actions' as const,
        flex: 1,
        align: 'right' as const,
        headerAlign: 'right' as const,
        getActions: (params: GridRowParams) => [
          <GridActionsCellItem
            showInMenu
            key={`view-${params.row.id}`}
            label="View"
            icon={<Visibility />}
            onClick={() => {
              const rowId = params.row.id?.toString() ?? '';
              const path = `/${routes.EMPLOYER_HOME}/${routes.EMPLOYER_POSTS_VIEW.replace(':id', rowId)}`;

              if (params.row.id) {
                navigate(path);
              }
            }}
          />,
          <GridActionsCellItem
            showInMenu
            key={`edit-${params.row.id}`}
            label="Edit"
            icon={<Edit />}
            onClick={() => {
              const row = params.row as Post;
              const rowId = row?.job?.id?.toString() ?? '';
              const path = `/${routes.EMPLOYER_HOME}/${routes.EMPLOYER_JOBS_VIEW.replace(':id', rowId)}`;

              if (rowId) {
                navigate(path);
              }
            }}
          />,
        ],
      },
    ],
    [navigate, deletePost],
  );

  useEffect(() => {
    if (searchParams.get('new')) {
      setOpen(true);
    }
  }, [searchParams, setOpen]);

  return (
    <DashboardPageContainer>
      <DataGrid<Post>
        query={search}
        columns={columns}
        initialState={{
          columns: {
            columnVisibilityModel: POST_INDEX_COLUMN_INITIAL_STATE,
          },
        }}
      />
    </DashboardPageContainer>
  );
};

export default EmployerPostIndex;
